'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useOpenClaimModal } from '@/provider/ClaimModalOpenProvider';
import useWallet from '../hooks/useWallet';
import isSessionExpired from '../utils/isSessionExpired';

const withAuth = <P extends object>(Component: React.ComponentType<P>) => {
  return function AuthHoc(props: P) {
    const router = useRouter();
    const { address } = useWallet();
    const { setIsDisconnect } = useOpenClaimModal();

    useEffect(() => {
      const isExpired = isSessionExpired();
      if (router?.pathname && isExpired && !!address) {
        setIsDisconnect(true);
      }
    }, [router?.pathname, setIsDisconnect, address]);

    return <Component {...props} />;
  };
};

export default withAuth;
